import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { captacionUploadQueue, initCaptacionUploadQueue } from "../../services/captacionUploadQueue";

/** Arranca la cola global al cargar la app (subidas siguen fuera de la ficha). */
export function CaptacionUploadBootstrap() {
  useEffect(() => {
    initCaptacionUploadQueue();
  }, []);
  return null;
}

/** Aviso global cuando hay subidas de captación activas y el usuario no está en la ficha. */
export default function BarraSubidaGlobal() {
  const location = useLocation();
  const [stats, setStats] = useState({ activos: 0 });

  useEffect(() => {
    return captacionUploadQueue.subscribe(setStats);
  }, []);

  const enFicha =
    location.pathname === "/propiedades/nueva" ||
    /^\/propiedades\/[^/]+\/editar$/.test(location.pathname);

  if (enFicha || stats.activos <= 0) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 16,
        left: 16,
        zIndex: 60,
        maxWidth: 340,
        background: "rgba(15, 23, 42, 0.94)",
        color: "#f8fafc",
        borderRadius: 10,
        padding: "10px 14px",
        boxShadow: "0 6px 24px rgba(0,0,0,0.3)",
        fontSize: 12,
        lineHeight: 1.45,
      }}
    >
      <strong>Subiendo fotos/documentos de captación…</strong>
      <div style={{ opacity: 0.9, marginTop: 4 }}>
        {stats.activos} archivo{stats.activos !== 1 ? "s" : ""} en curso. Pasará a Para Revisar al terminar.
      </div>
    </div>
  );
}
